import React from "react";
import PropTypes from "prop-types";
import FacebookLink from "./facebook_link";
import TwitterLink from "./twitter_link";

function RelatedLinks(props) {
  const { providerLinkedStatus } = props;

  return (
    <React.Fragment>
      <FacebookLink isFacebookLinked={providerLinkedStatus.facebook} />
      <TwitterLink isTwitterLinked={providerLinkedStatus.twitter} />
    </React.Fragment>
  );
}

RelatedLinks.propTypes = {
  providerLinkedStatus: PropTypes.objectOf(PropTypes.bool).isRequired,
};

export default RelatedLinks;
